import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { ConfirmationService } from 'primeng/api';
import { NotificationsService } from './notifications.service';

interface DeleteConfirmData {
    message: string;
    messageParameters?: any;
    translateMessage?: boolean;
    endpoint: string;
    idKey?: string;
    selection: any[];
    onAcceptClick?: (data?: any) => any;
    successCallback?: (data?: any) => any;
    errorCallback?: (error?: any) => any;
    completeCallback?: (data?: any) => any;
}

@Injectable({
    providedIn: 'root'
})
export class ConfirmDialogsService {


    constructor(
        private confService: ConfirmationService,
        private transloco: TranslocoService,
        private http: HttpClient,
        private notifications: NotificationsService,
        @Inject('ENVIRONMENT') private ENV: any
    ) { }

    showDeleteConfirmAuto(conf: DeleteConfirmData) {

        this.confService.confirm({
            message: (conf.translateMessage ?? true) ? this.transloco.translate(conf.message, conf.messageParameters ?? { count: conf.selection.length }) : conf.message,
            header: this.transloco.translate("deleteConfirm"),
            icon: "pi pi-trash",
            acceptButtonProps: {
                icon: "pi pi-trash",
                iconPos: "left",
                severity: "danger",
            },
            rejectButtonProps: {
                icon: "pi pi-times",
                severity: "secondary",
                iconPos: "left"
            },
            accept: () => {
                if (conf.onAcceptClick) {
                    conf.onAcceptClick();
                }
                this.http
                    .post(this.ENV.apiUrl + conf.endpoint, {
                        ids: conf.selection.map((el) => el[conf.idKey ?? "id"]),
                    })
                    .subscribe({
                        next: (data) => {
                            this.notifications.showNotification({
                                title: "recordsDeleted",
                                titleParams: { count: conf.selection.length },
                                translateDetailsParams: false,
                                severity: "success",
                                life: 3000,
                                addToHistory: false,
                            });
                            if (conf.successCallback) {
                                conf.successCallback(data);
                            }
                            if (conf.completeCallback) {
                                conf.completeCallback();
                            }
                        },
                        error: (error: any) => {
                            if (conf.errorCallback) {
                                conf.errorCallback(error);
                            }
                            if (conf.completeCallback) {
                                conf.completeCallback();
                            }
                            // this.notifications.showNotification(error);
                        },
                    });
            },
            reject: () => {
                if (conf.completeCallback) {
                    conf.completeCallback();
                }
            },
        });
    }

    showConfirmDialog(config:
        {
            title: string,
            translateTitle?: boolean,
            titleParameters?: any,
            message?: string,
            translateMessage?: boolean,
            messageParameters?: any,
            icon?: string,
            acceptButtonStyleClass?: string,
            rejectButtonStyleClass?: string,
            acceptIcon?: string,
            rejectIcon?: string,
            accept?: () => void,
            cancel?: () => void,
            dismissable?: boolean,
        }
    ) {
        this.confService.confirm({
            message: config.message ? ((config.translateMessage ?? true)
                ? this.transloco.translate(config.message, config.messageParameters ?? {})
                : config.message) : undefined,
            header: (config.translateTitle ?? true)
                ? this.transloco.translate(config.title, config.titleParameters ?? {})
                : config.title,
            icon: config.icon,
            acceptButtonStyleClass: config.acceptButtonStyleClass ?? "p-button-text p-button-text",
            rejectButtonStyleClass: config.rejectButtonStyleClass ?? "p-button-secondary p-button-text",
            acceptIcon: config.acceptIcon ?? "none",
            rejectIcon: config.rejectIcon ?? "none",
            accept: config.accept,
            reject: config.cancel,
            dismissableMask: config.dismissable ?? false,
            closeOnEscape: config.dismissable ?? false,
        });
    }
}
